import { ComponentRef, ElementRef, Injectable } from '@angular/core';

export interface IPlacementDictionary {
  top: any;
  left: any;
  right: any;
  bottom: any;
  topLeft?: any;
  topRight?: any;
  bottomLeft?: any;
  bottomRight?: any;
  default: any;
}

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  public static placementOffset = 10;

  public static getRandId() {
    return (Math.random() + 1).toString(36).substring(7);
  }

  public static getAutoPlacement(baseElement: ElementRef, element: ComponentRef<any>, dictionary: IPlacementDictionary, container?: HTMLElement) {
    const tooltipElement = element.location.nativeElement;
    const elementRect = tooltipElement.getBoundingClientRect();
    const baseElementRect = baseElement.nativeElement.getBoundingClientRect();
    const viewportWidth = container ? container.getBoundingClientRect().right + UtilService.placementOffset : window.innerWidth;
    const viewportHeight = container ? container.getBoundingClientRect().bottom + UtilService.placementOffset * 2 : window.innerHeight;

    const fitsTop =
      baseElementRect.top - elementRect.height > UtilService.placementOffset;

    const fitsBottom =
      baseElementRect.bottom + elementRect.height < viewportHeight - UtilService.placementOffset;

    const fitsLeft =
      baseElementRect.left - (elementRect.width - baseElementRect.width) > UtilService.placementOffset;

    const fitsRight =
      baseElementRect.right + (elementRect.width - baseElementRect.width) < viewportWidth - UtilService.placementOffset;

    if (fitsBottom && fitsRight) {
      return dictionary.bottom;
    } else if (fitsTop && fitsRight) {
      return dictionary.top;
    } else if (fitsLeft && fitsBottom) {
      return dictionary.left;
    } else if (fitsRight && fitsBottom) {
      return dictionary.right;
    } else if (fitsTop && fitsLeft && dictionary.topLeft) {
      return dictionary.topLeft;
    } else if (fitsTop && fitsRight && dictionary.topRight) {
      return dictionary.topRight;
    } else if (fitsBottom && fitsLeft && dictionary.bottomLeft) {
      return dictionary.bottomLeft;
    } else if (fitsBottom && fitsRight && dictionary.bottomRight) {
      return dictionary.bottomRight;
    } else {
      return dictionary.default;
    }
  }
}
